<template>
   <div>
       <el-dialog :visible.sync="dialogVisible"  width="90vw" :close-on-click-modal="false" top="30px">
           <div class="header">
               <div class="header-left">
                   <img src="@/assets/left_enable.png" style="width:21px;height:21px;margin-right:20px" @click="findHistory(false)"/>
                   <img src="@/assets/right_enable.png" style="width:21px;height:21px" @click="findHistory(true)"/>
               </div>
               <div class="header-title">机械特性数据</div>
               <div class="header-right">
                   <i class="el-icon-info" :class="['info-icon', { 'active': showRange }]" @click="toggleRange"></i>
                   <i class="el-icon-error" @click="dialogVisible = false"></i>
               </div>
           </div>
           <div class="dialog-content" v-loading="dialogLoading" element-loading-text="加载中..." element-loading-background="rgba(0, 0, 0, 0.7)">
               <el-tabs v-model="activeName" type="card" @tab-click="handleTabClick">
                <!-- <div class="pane-content">
                            <div class="content-chart">dddd</div>
                            <div class="content-params">eeee</div>
                        </div> -->
                    <el-tab-pane label="断路器机械特性" name="first"></el-tab-pane>
                    <el-tab-pane label="储能电机电流" name="second"></el-tab-pane>
                    <!-- <el-tab-pane label="主回路电流" name="third"></el-tab-pane> -->
                </el-tabs>
                <component :is="isComponent" :dataInfo="activeData" :dataDetails="activeData" :showRange="showRange" @loading-change="setChildLoading"></component>
           </div>

        </el-dialog>
   </div>
</template>

<script>
import * as echarts from 'echarts';
import * as device from '@/data/device.js'
import dlq from '../../dlq.vue'
import zhl from '../../zhl.vue'
import cnjd from '../../cndj.vue'
import NearestMotorSeq from './NearestMotorSeq2.vue'
   export default {
       name:'',
       props:{
           visible:{
               type:Boolean,
               default:false
           },
           dataDetails:{
               type:Object,
               default:()=>{}
           },
       },
       computed:{
           dialogVisible:{
               get(){
                   return this.visible;
               },
               set(val){
                   this.$emit('update:visible',val)
               }
           },
           isComponent() {
                return this.componentsList[this.activeName];
            },
           activeData() {
                return this.activeName === 'second' ? this.motorData : this.coilData;
            },
           activeMechDataType() {
                return this.activeName === 'second' ? 'motor' : 'coil';
            },
           dialogLoading() {
                return this.contentLoading || this.childLoading;
           }
       },
       data(){
           let This = this;
           return {
               activeName:'first',
               componentsList:{
                    first:resolve => {require(['./NearestMotorSeq1.vue'], resolve)},
                    second:resolve => {require(['./NearestMotorSeq2.vue'], resolve)},
                    third:zhl
               },
               coilData: {},
               motorData: {},
               showRange: false,
               contentLoading: false,
               childLoading: false
           }
       },
       mounted(){
       },
       created (){
          if(this.dataDetails.mech_id){
            this.setMechData('coil', this.dataDetails.trend)
          }else{
            this.getSensorDetails(this.dataDetails)
          }
       },
        methods: {
            toggleRange() {
                this.showRange = !this.showRange;
            },
            setChildLoading(val) {
                this.childLoading = val;
            },
            handleTabClick() {
                this.syncTabData()
            },
            getDataId(data) {
                return data && (data.sensor_data_id || data._id || data.id || data.mech_id)
            },
            setMechData(type, data) {
                if (type === 'motor') {
                    this.motorData = data || {}
                } else {
                    this.coilData = data || {}
                }
            },
            syncTabData() {
                if (this.activeName === 'second') {
                    this.syncMotorDataByCoil()
                } else {
                    this.syncCoilDataByMotor()
                }
            },
            syncMotorDataByCoil() {
                const coilId = this.getDataId(this.coilData)
                if (!coilId) return
                this.contentLoading = true
                device.getNearestMotorSeq({mech_id: coilId}).then(res => {
                    this.setMechData('motor', res && res.data && JSON.stringify(res.data) !== '{}' ? res.data : {})
                }).catch(err => {
                    console.log(err)
                }).finally(() => {
                    this.contentLoading = false
                })
            },
            syncCoilDataByMotor() {
                const motorId = this.getDataId(this.motorData)
                if (!motorId) return
                this.contentLoading = true
                device.getNearestCoilSeq({motor_id: motorId}).then(res => {
                    this.setMechData('coil', res && res.data && JSON.stringify(res.data) !== '{}' ? res.data : {})
                }).catch(err => {
                    console.log(err)
                }).finally(() => {
                    this.contentLoading = false
                })
            },
            wait (ms) {
                return new Promise(resolve => setTimeout(resolve, ms))
            },
            getHistoryRequestBody(data, mechDataType, is_next) {
                if (!data) return null
                const create_date = data.create_date || data.update_date
                const point_id = data.point_id || data.cal_point_id
                if (!create_date || !point_id) return null
                return {
                    cal_point_id: point_id,
                    cal_date: create_date,
                    is_next: is_next,
                    point_ids: [point_id],
                    mech_data_type: mechDataType
                }
            },
            findHistory(is_next) {
                const request_body = this.getHistoryRequestBody(this.activeData, this.activeMechDataType, is_next)
                if (!request_body) return
                this.loading = this.$loading({
                    target: '.el-dialog',          
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                const startTime = Date.now();
                device.findHistoryData(request_body).then(res => {
                    if (res.data.length > 0 && res.data[0] != null ) {
                        this.setMechData(this.activeMechDataType, res.data[0])
                    } else {
                        if (is_next) {
                            this.$message({type:'info',message:'已是最新一条'});
                        } else {
                            this.$message({type:'info',message:'已是最早一条'});
                        }

                    }

                }).catch((err) => {
                    console.log(err)
                }).finally(() => {
                    // 计算已消耗时间，确保最少显示1秒
                    const elapsed = Date.now() - startTime;
                    const delay = Math.max(0, 500 - elapsed); // 不足1秒则补全延迟
                    
                    // 等待延迟后关闭loading
                    this.wait(delay).then(() => {
                        this.loading.close();
                    });
                });
            },
            getSensorDetails(item) {
                this.contentLoading = true;
                device.sensorDetails({sensor_data_id:item.sensor_data_id,sensor_type:item.sensor_type}).then(res => {
                    this.setMechData('coil', res.data)
                }).finally(() => {
                    this.contentLoading = false;
                })
            }
        }
   }
</script>
<style lang='less' scoped>
    /deep/.el-dialog__header{
       padding: 0;
       background: #141E38;
       border:none;
       .el-dialog__headerbtn{
           top: 3px;
       }
       .el-dialog__headerbtn .el-dialog__close{
           color:#fff;
           display: none;
       }
    }
      /deep/.el-dialog__body{
        padding: 0 0 20px 0;
        color: #fff;
        background: #2C2E30
    }
    .dialog_header{
        height:46px;line-height: 46px;
        width:100%;text-align: center;color:#fff;font-size: 20px;border-bottom: solid 2px #ccc;;
    }
    /deep/.el-tabs{
        padding-top: 15px;;
        .el-tabs__item{
            border:solid 1px #ccc;
            height:30px;line-height: 30px;;
            font-size: 16px;
        }
        .el-tabs__item:last-child{
            border-right:solid 1px #ccc;
        }
        .el-tabs__nav-wrap{
            margin-bottom:0;
        }
        .el-tabs__item.is-active{
            /* background:#D7D7D7; */
            background: #F4D759;
            color:#000;
        }
        .el-tabs__item:hover{
            color:#fff;
        }
        .el-tabs__header{
            border:none;
            padding:0 20px;
            margin:0;
        }
        .el-tabs__nav{
            border:none;
        }
        .el-tab-pane{
            width:100%;
        }
        .el-tabs__item.is-active:hover{
            color:#000;
        }
    }
    /deep/.el-tabs--card>.el-tabs__header .el-tabs__nav {
        border-radius: none;
    }
    .header {
        width: 100%;
        height: 46px;
        padding: 0 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #fff;
        font-size: 20px;
        border-bottom: solid 2px #ccc;
    }
    .header-left {
        display: flex;
        align-items: center;
    }
    .header-title {
        flex: 1;
        text-align: center;
    }
    .header-right {
        display: flex;
        align-items: center;
    }
    .header-right i {
        font-size: 20px;
        margin-left: 15px;
        cursor: pointer;
        transition: color 0.3s;
    }
    .header-right .el-icon-error {
        font-size: 25px;
        color: #CA5051;
    }
    .header-right .el-icon-info {
        color: #4da3ff;
    }
    .header-right .el-icon-info:hover,
    .header-right .el-icon-info.active {
        color: #67c23a;
    }
</style>



// WEBPACK FOOTER //
// src/view/site/components/NearestMotorSeq/NearestMotorSeqDialog.vue